// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `span.show-more-less-clickable {
    cursor:pointer;
    text-decoration:underline;
}

span.show-more-less-clickable:hover{
    text-decoration:none;
}`, "",{"version":3,"sources":["webpack://./node_modules/react-show-more-text/lib/ShowMoreText.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":["span.show-more-less-clickable {\n    cursor:pointer;\n    text-decoration:underline;\n}\n\nspan.show-more-less-clickable:hover{\n    text-decoration:none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
